export const mainUri = "https://server.myprepzone.com/api";
// export const mainUri = "http://localhost:5000/api";
export const mainImagesUri = "https://server.myprepzone.com";
